// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".not-valid-text[data-v-1cab6684]{top:100px}.not-valid-text[data-v-1cab6684],.result-box[data-v-1cab6684],.text-align-center[data-v-1cab6684]{text-align:center}.result-box[data-v-1cab6684]{font-size:200%;color:#fff}.result-euro[data-v-1cab6684]{font-size:125%;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
